import { render, staticRenderFns } from "./SegmentJobBoard.vue?vue&type=template&id=ed11d8aa&"
import script from "./SegmentJobBoard.vue?vue&type=script&lang=js&"
export * from "./SegmentJobBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports